'use client';
import { motion } from 'framer-motion';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { ColorType } from '@/theme';
import { CWITNESSCARDMODAL_EASE_CURVE } from './cwitnesscardmodalConstants';
import { CWITNESSCARDMODAL_BACKDROP_STYLE } from './cwitnesscardmodalStyles';
interface CwitnesscardmodalBackdropProps {
    onClose: () => void;
}
export function CwitnesscardmodalBackdrop({ onClose, }: CwitnesscardmodalBackdropProps) {
    return <motion.div data-el="Cwitnesscardmodal/Backdrop/Root" style={CWITNESSCARDMODAL_BACKDROP_STYLE} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3, ease: CWITNESSCARDMODAL_EASE_CURVE }} onClick={onClose}>
            <Ccontainer backgroundColor={ColorType.Black} backgroundOpacity={0.9} backdropBlur={20} width="100%" height="100%"/>
        </motion.div>
        ;
}
